import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'
import { v4 } from 'uuid'
import Topbar from '../Topbar/';

import Button from '@material-ui/core/Button';

import PhotoCamera from '@material-ui/icons/PhotoCamera';

import { uploadPhoto, snapVideoData } from './picture-messaging';

import { initUserMedia, getVideoElementDetails } from './user-media'

import { sendMessage, watchConversation } from '../MessagingScreen/actions'

import JitsuFlyerView from '../JitsuFlyerView'
import { closeRtcTracks, initPeerConnectionWithTwiiloTurn } from '../JitsuFlyerView/rtcUtils'
import { JitsuCamponentBottomOptions } from './JitsuCamponentBottomOptions'
import { splitSessionData, getVideoChat } from '../Conversations/middleware/conversation-subscriptions'

import { ImagePreview } from './ImagePreview'
import { updateVideoChat, addVideoChatId } from '../MessagingScreen/actions/videoChat'
import './camponent.css'

class JitsuCamponent extends Component {
  constructor() {
    super();

    this.state = {
      previewImageDataUrl: null,
      canvasBlobData: null,
      showVideoFlyer: false,
      showVideoChatWaiting: false
    }

  }

  componentDidMount() {

    var {watchConversation, messaginScreen: {id, videoChatId}} = this.props;
    var {setConversationSubsrciption} = this;

    setConversationSubsrciption()

    if (videoChatId) {
      console.log('fourn video videoChatId', videoChatId)
      initUserMedia()

        .then(localStream => {
          var {videoElement, rect: {height, width}} = getVideoElementDetails("main-camponent-video")

          this.setState({
            localStream
          })

          this.initJitsuCamponentWithVideoChatId(localStream, videoChatId)

        })

    } else {

      this.initJitsuCamponentDefaultStream()

    }

  }

  onTrack = (ontrackevent) => {

    console.log("on track", ontrackevent);
    this.setState({
      showVideoChatWaiting: false
    })
    var {videoElement, rect: {height, width}} = getVideoElementDetails("main-camponent-video");

    videoElement.srcObject = ontrackevent.streams[0];
    videoElement.volume = .7;

    videoElement.play()

    videoElement.onload = () => {
      console.log("on onload", videoElement.srcObject, videoElement)

      //videoElement.play()

    }

    this.setState({
      showVideoFlyer: true,
      flyerScrStream: this.state.localStream
    })

  }

  initJitsuCamponentWithVideoChatId = (localStream, videoChatId) => {

    var {sendCanidateInfo, onTrack} = this;

    var {sendMessage, watchConversation, messaginScreen: {id, messages}, locationUtil: {params}, user} = this.props;

    var videoChat = getVideoChat(messages, videoChatId);

    if (videoChat) {

      var {members} = videoChat

      var {otherSessions, mySessionSearch} = splitSessionData(members, user);
      var remoteSession = otherSessions[0];

      initPeerConnectionWithTwiiloTurn({
        sendCanidateInfo,
        onTrack,
        localStream,
        remoteSession: new RTCSessionDescription(remoteSession.sessionDescription)
      })

        .then((peerConnectionResponse) => {
          var {localPeerConnection} = peerConnectionResponse

          return this.setLocalPeerConnection(localPeerConnection, true)

        })

        .then(peerConnectionResponse => {
          var {localPeerConnection} = peerConnectionResponse

          updateVideoChat({
            videoChat,
            conversationId: id,
            user,
            mySessionDescription: {
              sdp: localPeerConnection.localDescription.sdp,
              type: "answer"
            }
          })

        })

    } ///

  }

  setConversationSubsrciption = (next) => {

    var {watchConversation, messaginScreen: {id}} = this.props;

    var {onNotificationReponse} = this;

    watchConversation(id, onNotificationReponse)

      .then((action) => {

        var {unsubscribe} = action;

        this.setState({
          unsubscribeFromConversationWatch: unsubscribe
        })

      })

  }

  onNotificationReponse = (onNotificationReponse) => {

    var {localPeerConnection, hasRemoteStream} = this.state;
    var {user} = this.props

    if (!hasRemoteStream && localPeerConnection) {

      var {otherSessions} = onNotificationReponse

      this.setState({
        hasRemoteStream: true
      })

      localPeerConnection.setRemoteDescription(new RTCSessionDescription(otherSessions[0].sessionDescription)).catch((e) => console.log(e))

    }

  }

  componentWillUnmount() {
    closeRtcTracks(this.state.localStream)
    var {unsubscribeFromConversationWatch, localPeerConnection} = this.state;

    if (localPeerConnection) {

      localPeerConnection.close();

    }
    unsubscribeFromConversationWatch()
  }

  sendPic = () => {

    var {canvasBlobData} = this.state;

    uploadPhoto(canvasBlobData)

      .then(({downloadURL}) => {

        var {messaginScreen: {id, messages}, sendMessage} = this.props;

        const {user} = this.props;

        sendMessage(id,
          {
            from: user.uid,
            img: downloadURL,
            created: new Date().getTime()
          })

        this.cancelPreview()

      })

  }

  initJitsuCamponentDefaultStream() {

    initUserMedia()

      .then(stream => {

        this.setState({
          localStream: stream
        }, () => {

          var {localStream} = this.state

          var {videoElement, rect: {height, width}} = getVideoElementDetails("main-camponent-video")

          videoElement.srcObject = stream;

          videoElement.volume = 0;

          videoElement.play()

        })

      })

  }

  cancelPreview = () => {

    this.setState({
      previewImageDataUrl: null,
      canvasBlobData: null
    })

    this.initJitsuCamponentDefaultStream()

  }

  render() {

    var {takephoto, shareVideoToggle, sendPic, cancelPreview} = this;

    var {previewImageDataUrl, showVideoFlyer, peerConnection, showVideoChatWaiting, flyerScrStream} = this.state;

    return (
      <div style={ { backgroundColor: "black" } } className="h-100 d-flex flex-column">
        <Topbar/>
        <div className="flex-1 d-flex flex-column">
          { showVideoChatWaiting &&
            <div style={ { zIndex: 10, height: 20, position: 'absolute', marginTop: 20 } } className="d-flex w-100 justify-content-around align-items-center">
              <img className={ `animated infinite rotateIn` } style={ { height: '3vh' } } src={ `./images/sabers.svg` } />
              <img className={ `animated infinite rotateIn` } style={ { height: '3vh' } } src={ `./images/star.png` } />
              <span className="animated infinite pulse waiter">Waiting for other user ...</span>
              <img className={ `animated infinite rotateIn` } style={ { height: '3vh' } } src={ `./images/sabers.svg` } />
              <img className={ `animated infinite rotateIn` } style={ { height: '3vh' } } src={ `./images/star.png` } />
            </div> }
          { !previewImageDataUrl
            &&
            <div className="h-100 w-100" style={ { zIndex: "1", position: 'relative' } }>
              <div style={ { zIndex: "1" } } className='h-100 w-100 d-flex justify-content-center'>
                <video className="h-100 w-100" id="main-camponent-video">
                  Video stream not available.
                </video>
              </div>
              { this.state.showVideoFlyer && <JitsuFlyerView {...{ videoSrc: flyerScrStream }} /> }
            </div> }
          <ImagePreview {...{ previewImageDataUrl, sendPic, cancelPreview }}/>
          <JitsuCamponentBottomOptions {...{ takephoto, shareVideoToggle, showVideoFlyer }} />
        </div>
      </div>
      );
  }

  sendCanidateInfo = (candidateEvent) => {

    console.log("on sendCanidateInfo", candidateEvent)

  }

  shareVideoToggle = () => {

    var {localStream} = this.state
    if (this.state.shareVideoToggle) {

      this.setState({
        shareVideoToggle: false
      }, () => this.initJitsuCamponentDefaultStream())

    } else {

      this.setState({
        showVideoChatWaiting: true
      })

      var {sendCanidateInfo, onTrack} = this;

      initPeerConnectionWithTwiiloTurn({
        sendCanidateInfo,
        onTrack,
        localStream
      })

        .then((peerConnectionResponse) => {
          var {localPeerConnection} = peerConnectionResponse

          return this.setLocalPeerConnection(
            localPeerConnection
          )

        })

        .then(peerConnectionResponse => {

          var {localPeerConnection} = peerConnectionResponse

          var {user, addVideoChatId, messaginScreen: {id, messages}, sendMessage} = this.props;

          var newVideoChatId = v4()

          sendMessage(id,
            {
              from: user.uid,
              videoChat: {
                id: newVideoChatId,
                members: [
                  {
                    userId: user.uid,
                    sessionDescription: {
                      sdp: localPeerConnection.localDescription.sdp,
                      type: "offer"
                    },
                  }
                ]
              },
              created: new Date().getTime()
            })

          addVideoChatId(newVideoChatId)

        })

      this.setState({
        shareVideoToggle: true
      })

    }

  }

  setLocalPeerConnection = (localPeerConnection, hasRemoteStream) => {

    return new Promise((resolve, reject) => {

      this.setState({
        localPeerConnection,
        hasRemoteStream
      }, () => {
        resolve({
          localPeerConnection
        })
      })

    })

  }

  takephoto = () => {

    var videoElementData = getVideoElementDetails("main-camponent-video")

    if (!this.state.showVideoFlyer) {

      snapVideoData(videoElementData)

        .then(({toBlobResult, canvas}) => {

          this.setState({
            previewImageDataUrl: canvas.toDataURL(),
            canvasBlobData: toBlobResult
          })

        })

    }
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  messaginScreen: state.messaginScreen,
  locationUtil: state.locationUtil
})

export default connect(mapStateToProps, {
  sendMessage,
  watchConversation,
  addVideoChatId
})(JitsuCamponent)


// WEBPACK FOOTER //
// ./src/Components/JitsuCamponent/index.js